// wt-responsive-media_v8.js

document.addEventListener("DOMContentLoaded", function() {
  const mediaElements = document.querySelectorAll('.responsive-media-container');

  mediaElements.forEach(function(container) {
    const url = container.getAttribute('data-url');
    const type = container.getAttribute('data-type');

    // Clear existing content inside the container
    container.innerHTML = '';

    let mediaElement;

    if (type === 'video' && url.includes('youtube.com/embed/')) {
      mediaElement = document.createElement('iframe');
      mediaElement.src = url;
      mediaElement.frameBorder = '0';
      mediaElement.allowFullscreen = true;
    }

    mediaElement.style.width = '100%';
    mediaElement.style.height = '100%';
    mediaElement.style.border = '0';
    mediaElement.style.objectFit = 'cover';

    container.appendChild(mediaElement);
  });
});
